import React, { useMemo } from 'react';
import { BorderColorOutlined, StarBorder, GradingOutlined } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import DropdownButton from 'components/offer/edit/workflow/components/WorkflowDropdownButton';
import { Button } from '@totalsoft/rocket-ui';
import PropTypes from 'prop-types';

const HeaderOffer = ({ offerOptionsAvailability, history }) => {
  const { t } = useTranslation();

  const list = useMemo(
    () =>
      [
        {
          label: (
            <>
              <GradingOutlined sx={{mr:1}} />
              {t('Tooltips.AddNewOffer')}
            </>
          ),
          handler: () => history.push('/offers/new'),
          enabled: offerOptionsAvailability.addOffer ?? false
        },
        {
          label: (
            <>
              <BorderColorOutlined sx={{mr:1}} />
              {t('Tooltips.AddContractModification')}
            </>
          ),
          handler: () => history.push('/offers/restructuring/new'),
          enabled: offerOptionsAvailability.addContractModification ?? false
        },
        {
          label: (
            <>
              <StarBorder sx={{mr:1}} />
              {t('Tooltips.AddFacilityFrameOffer')}
            </>
          ),
          handler: () => history.push('/offers/facilityFrame/new'),
          enabled: offerOptionsAvailability.addFacilityFrame ?? false
        }
      ].filter(x => x.enabled),
    [
      history,
      offerOptionsAvailability.addContractModification,
      offerOptionsAvailability.addFacilityFrame,
      offerOptionsAvailability.addOffer,
      t
    ]
  );


  switch (list.length) {
    case 0:
      return <></>;
    case 1:
      return (
        <Button color='primary' variant='contained' onClick={list[0].handler}>
          {list[0].label}
        </Button>
      );
    default:
      return <DropdownButton options={list}>{t('Tooltips.AddNew')}</DropdownButton>;
  }
};

HeaderOffer.propTypes = {
  offerOptionsAvailability: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired
};
export default HeaderOffer;
